import React from "react";

import { IToggleModalWithLocalState } from "@vahak/core/dist/hooks";

import { POSTING_FORM_MODAL_ORIGINATION_PAGE, useLoadLorryPosting } from "../../../../context/load-lorry-posting";
import { LOAD_CREATION_FORM_IDS, LORRY_CREATION_FORM_IDS } from "../../helpers/constants";
import useOpenNewLoadPosting from "../../../../hooks/useOpenNewLoadPosting";
import { VehicleRestrictionPopup } from "../../vehicle-restriction-popup";

const LorryNotAllowedPopup = ({
    isModalOpen,
    toggleModal
}: Pick<IToggleModalWithLocalState, "isModalOpen" | "toggleModal">) => {
    const { clearPostingData, updateLoadLorryPostingData, loadLorryData, openLorryPostingModal } =
        useLoadLorryPosting();
    const openNewLoadPosting = useOpenNewLoadPosting();

    const closeAndClear = () => {
        clearPostingData();
        toggleModal();
    };

    const handlePrimary = () => {
        const originationPage = loadLorryData?.originationPage!;
        if (loadLorryData?.type === "load") {
            closeAndClear();
            openNewLoadPosting({
                originationPage,
                loadStep: LOAD_CREATION_FORM_IDS.LOAD_LOCATION_DETAILS
            });
            return;
        }

        closeAndClear();
        setTimeout(() => {
            updateLoadLorryPostingData({
                category: "post",
                isModalOpen: true,
                type: "lorry",
                originationPage: POSTING_FORM_MODAL_ORIGINATION_PAGE.MARKETPLACE
            });
            openLorryPostingModal(LORRY_CREATION_FORM_IDS.VEHICLE_NUMBER);
        }, 100);
    };

    return (
        <VehicleRestrictionPopup
            id="lorry-not-allowed-popup"
            isOpen={isModalOpen}
            kind="unsupported_category"
            onCancel={closeAndClear}
            onPrimary={handlePrimary}
            primaryLabelOverride={loadLorryData?.type === "load" ? "Post New Load" : undefined}
        />
    );
};

export default LorryNotAllowedPopup;
